"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyPrimitiveDimensionProps;

//
function applyPrimitiveDimensionProps(dimensionName, props) {
  switch (dimensionName) {
    case 'x':
    case 'y':
      return {
        width: props.width,
        height: props.height
      };

    default:
      return {};
  }
}